import { ref, computed, inject } from 'vue';
import { defineStore } from 'pinia';
import { useApi } from '@/plugins/api';
import { useStoreRestaurant } from './restaurant';

export const useStoreCustomer = defineStore('customer', () => {
  let api = useApi();
  let customer = ref(null);

  const rStore = useStoreRestaurant();
  const signupFields = ref([]);
  const customerFields = ref([]);
  const loyaltyPointRewards = ref([]);
  const tracking = ref(null); // this is the main tracking, is not used inside the tracking page but in the home page

  const login = async (credentials) => {
    let { data } = await api.post('customer/login', credentials);
    let { done, customer: _customer } = data;

    customer.value = _customer;
    return data;
  }

  const signup = async (credentials) => {
    let { data } = await api.post('customer/signup', credentials);
    let { done, customer: _customer } = data;

    customer.value = _customer;
    return data;
  }

  const getCustomerFields = async (context = "signup") => {
    try {
      let { data } = await api.get('customer/customer_fields/' + context);
      if (context == 'signup') {
        signupFields.value = data;
      } else {
        customerFields.value = data;
      }
      return data;
    } catch (e) {
      return e;
    }
  }

  const getCustomer = async () => {
    try {
      let { data } = await api.get('customer');
      customer.value = data;
    } catch (e) {
    }
  }

  const logout = async () => {
    await api.get('customer/logout');
    customer.value = null;
  }

  const getLoyaltyRewards = async (posId = null) => {
    try {
      let hasSubrestaurants = rStore.restaurant.has_subrestaurants;
      let params = {};
      if (hasSubrestaurants) {
        params = { pos_id: posId };
      }
      let { data } = await api.get('customer/loyalty_rewards', { params });
      loyaltyPointRewards.value = data;
      return data;
    } catch (e) {
      return
    }
  }

  const getLoyalty = async (posId = null) => {
    try {
      let hasSubrestaurants = rStore.restaurant.has_subrestaurants;
      let params = {};
      if (hasSubrestaurants) {
        params = { pos_id: posId };
      }
      let { data } = await api.get('customer/loyalty', { params });
      return data;
    } catch (e) {
      return
    }
  }

  const getOrderHistory = async (page) => {
    try {
      let { data } = await api.get('customer/orders', { params: { page } });
      return data;
    } catch (e) {
      return e;
    }
  }

  const copyOrder = async (orderId) => {
    try {
      let { data } = await api.post('customer/act/copy_order', { order_id: orderId });
      return data;
    } catch (e) {
      return e;
    }
  }

  const checkTracking = async () => {
    try {
      let { data } = await api.get('customer/check_tracking');
      tracking.value = data;
      return data;
    } catch (e) {
      return e;
    }
  }

  const validateQrCode = async (code, context) => {
    try {
      let { data } = await api.post('customer/act/qrcode', { qrcode: code, context });
      return data;
    } catch (e) {
      console.error(e);
      return e;
    }
  }

  const updateCustomer = async (data) => {
    try {
      let { data: _data } = await api.post('customer/settings', data);
      return _data;
    } catch (e) {
      return e;
    }
  }

  const deleteCustomer = async (data) => {
    try {
      let { data: _data } = await api.post('customer/delete', data);
      return _data;
    } catch (e) {
      console.error(e);
      return e;
    }
  }

  const resetPassword = async (data) => {
    try {
      let { data: _data } = await api.post('customer/reset_password', data);
      return _data;
    } catch (e) {
      console.error(e);
      return e;
    }
  }

  return {
    customer, signupFields, customerFields, loyaltyPointRewards, tracking,
    login, getCustomer, logout, signup, getCustomerFields, getLoyaltyRewards,
    getLoyalty, getOrderHistory, copyOrder, checkTracking, validateQrCode,
    updateCustomer, deleteCustomer, resetPassword
  };
});
